<template>
  <div
    class="thumb"
    :class="{'thumb--preview': preview}"
    :style="{'width': width + 'px', 'height': height + 'px'}" >
    <img @load="setPortraitClass"
         class="image-thumb"
         :src="pic"
         :alt="alt">
    <a href="#"
       v-if="showDeleteBtn"
       class="thumb-del-btn absolute"
       @click.prevent="$emit('onDelete')">
      <md-icon>close</md-icon>
    </a>
  </div>
</template>

<script>
  export default {
    name: "ImageThumbnail",
    props: {
      pic: {
        type: String,
        default: '',
        required: true,
      },
      alt: {
        type: String,
        default: '',
      },
      width: {
        type: Number,
        default: 75,
      },
      height: {
        type: Number,
        default: 75,
      },
      preview: {
        type: Boolean,
        default: false,
      },
      showDeleteBtn: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      setPortraitClass(e) {
        if (e.currentTarget.classList) {
          if (e.currentTarget.naturalHeight > e.currentTarget.naturalWidth) {
            e.currentTarget.classList.add('portrait');
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .thumb {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    overflow: hidden;
    position: relative;
    &:hover {
      box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
    }
    &--preview {
      border: 2px dashed #4caf50;
      .image-thumb {
        filter: opacity(0.5);
      }
    }
    &-del-btn {
      top: 0;
      right: 0;
      background-color: #00000080;
      .md-icon {
        color: #ffffff !important;
        font-size: 15px !important;
      }
    }
  }

  .image-thumb {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 100% !important;
    width: auto !important;
    max-width: unset !important;
    transform: translate(-50%, -50%);
    &.portrait {
      width: 100% !important;
      height: auto !important;
    }
  }
</style>
